import { PencomRoutes } from "@/router/PencomRoutes";

/**
 * Employer Code Request flow: 3 steps.
 * Step 1: Organisation Details (EmployerCodeRegPage)
 * Step 2: Employer Details (EmployerDetailsPage)
 * Step 3: Verify Email (EmployerRegEmailVerificationPage) → then Success
 */
export const EMPLOYER_REG_STEP_FLOW = [
  { path: PencomRoutes.EMPLOYER_CODE_REG, label: "Organisation Details" },
  { path: PencomRoutes.EMPLOYER_DETAILS, label: "Employer Details" },
  { path: PencomRoutes.EMPLOYER_REG_EMAIL_VERIFICATION, label: "Verify Email" },
] as const;

export const EMPLOYER_REG_TOTAL_STEPS = EMPLOYER_REG_STEP_FLOW.length;

export function getEmployerRegStep(pathname: string): {
  step: number;
  total: number;
  label: string;
} | null {
  const index = EMPLOYER_REG_STEP_FLOW.findIndex((s) => s.path === pathname);
  if (index === -1) return null;
  return {
    step: index + 1,
    total: EMPLOYER_REG_TOTAL_STEPS,
    label: EMPLOYER_REG_STEP_FLOW[index].label,
  };
}
